module.exports = __webpack_public_path__ + "img/choccolocco-logo.76a69b03.jpg";